import React, { useReducer, useState } from 'react';
import {
  Form,
  Row,
  Col,
  Input,
  Button,
  Upload,
  Select,
  Divider,
  Typography,
  Space,
  message,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import AddressUnitsSelector from '../../components/common/AddressUnitSelector';
import _ from 'lodash';
import { commonRegExp } from '../../utils';
import { addressStyleProps } from '../../utils/format';
import StepFooter from '../../components/stepFooter/StepFooter';

const { Title } = Typography;
const { Option } = Select;

/** Талбарууд картын бүтэн өргөнөөр сунахгүй — зүүн талд багцлагдана */
const FORM_MAX_WIDTH = 960;

const actions = {
  imageChange: 'IMAGE_CHANGE',
};

const initialState = {
  certificateFront: null,
  certificateBack: null,
};

function reducer(state, action) {
  switch (action.type) {
    case actions.imageChange: {
      const { key, file } = action.payload;

      return {
        ...state,
        [key]: file,
      };
    }
    default:
      return state;
  }
}

const OrganizationForm = ({
  onSubmit,
  categories,
  setMerchantAddress,
  submitting = false,
  categoriesLoading = false,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState, undefined);

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  const [addressArray, setAddressArray] = useState([]);
  const isValidFileSize = (file) => file.size < 5000001;

  const beforeUpload = (file) => {
    if (!isValidFileSize(file)) {
      message.error('Файлын хэмжээ 5mb -аас бага байх ёстой!');
    }

    return isValidFileSize(file);
  };

  const onHandleAddress = (value) => {
    setAddressArray(value);
    setMerchantAddress(value);
  };

  return (
    <Form onFinish={onSubmit} autoComplete="off" layout="vertical">
      <div style={{ maxWidth: FORM_MAX_WIDTH }}>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Компанийн нэр"
              name="name"
              rules={[{ required: true, message: 'Нэр оруулна уу' }]}
            >
              <Input placeholder="Компанийн нэр" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Регистрийн дугаар"
              name="registrationNumber"
              rules={[
                {
                  required: true,
                  message: 'Регистрийн дугаар оруулна уу',
                },
                {
                  pattern: new RegExp(commonRegExp.orgRegistrationNumber),
                  message: 'Регистрийн дугаар буруу байна.',
                },
              ]}
            >
              <Input placeholder="1234567" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="brandLogo"
              label="Бизнесийн лого"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              rules={[{ required: true, message: 'Бизнесийн лого оруулна уу' }]}
            >
              <Upload
                listType="picture"
                beforeUpload={() => false}
                multiple={false}
                maxCount={1}
                style={{ width: '100%' }}
              >
                <Button icon={<UploadOutlined />} block>
                  Зураг хуулах
                </Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="category"
              label="Үйл ажиллагааны чиглэл"
              rules={[{ required: true, message: 'Бүтцийн зураг оруулна уу' }]}
            >
              <Select loading={categoriesLoading}>
                {categories.map((option) => {
                  return (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="phoneNumber"
              label="Утас"
              rules={[{ required: true, message: 'Утас оруулна уу' }]}
            >
              <Input placeholder={'99999999'} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="email"
              label="И-Мэйл"
              rules={[{ required: true, message: 'И-Мэйл оруулна уу' }]}
            >
              <Input placeholder={'Таны и-мэйл'} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="website"
              label="Вэбсайт"
              rules={[{ required: false, message: 'Вэбсайт оруулна уу' }]}
            >
              <Input placeholder={'www.example.com'} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="address"
              label="Бүртгэлтэй хаяг"
              rules={[{ required: true, message: 'Бүртгэлтэй хаяг оруулна уу' }]}
            >
              <Input placeholder={'УБ...'} />
            </Form.Item>
          </Col>
        </Row>
        <Divider />
        <Title level={5}>Улсын бүртгэлийн гэрчилгээ</Title>
        <Row gutter={16} style={{ marginTop: 20 }}>
          <Col>
            <Form.Item
              name="certificateFront"
              label="Урд тал"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              rules={[
                {
                  required: true,
                  message: 'Улсын бүртгэлийн гэрчилгээний урд талын зургийг оруулна уу',
                },
              ]}
              shouldUpdate
            >
              <Upload
                showUploadList={false}
                beforeUpload={beforeUpload}
                maxCount={1}
                multiple={false}
                onChange={({ fileList: [{ originFileObj: file }] }) => {
                  if (isValidFileSize(file)) {
                    dispatch({
                      type: actions.imageChange,
                      payload: {
                        file,
                        key: 'certificateFront',
                      },
                    });
                  }
                }}
              >
                {state.certificateFront ? (
                  <Space
                    size={16}
                    style={{ background: '#fff', padding: '4px 16px', height: '100%' }}
                  >
                    {state.certificateFront?.type === 'application/pdf' ? (
                      <embed
                        src={URL.createObjectURL(state.certificateFront)}
                        style={{ width: 100 }}
                        alt=""
                      />
                    ) : (
                      <img
                        src={URL.createObjectURL(state.certificateFront)}
                        style={{ width: 100 }}
                        alt="Гэрчилгээний урд тал"
                      />
                    )}
                    <div>{_.truncate(state.certificateFront?.name, { length: 13 }) ?? ''}</div>
                  </Space>
                ) : (
                  <Button icon={<UploadOutlined />}>Хуулах</Button>
                )}
              </Upload>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item
              name="certificateBack"
              label="Ард тал"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              shouldUpdate
            >
              <Upload
                showUploadList={false}
                maxCount={1}
                multiple={false}
                beforeUpload={beforeUpload}
                onChange={({ fileList: [{ originFileObj: file }] }) => {
                  if (isValidFileSize(file)) {
                    dispatch({
                      type: actions.imageChange,
                      payload: {
                        file,
                        key: 'certificateBack',
                      },
                    });
                  }
                }}
              >
                {/* {
                                state.certificateBack
                                    ?   <img src={URL.createObjectURL(state.certificateBack)} style={{ width: '100%', maxHeight: '100%' }} alt=''/>
                                    :   uploadButton
                            } */}

                {state.certificateBack ? (
                  <Space
                    size={16}
                    style={{ background: '#fff', padding: '4px 16px', height: '100%' }}
                  >
                    {state.certificateBack?.type === 'application/pdf' ? (
                      <embed
                        src={URL.createObjectURL(state.certificateBack)}
                        style={{ width: 100 }}
                        alt=""
                      />
                    ) : (
                      <img
                        src={URL.createObjectURL(state.certificateBack)}
                        style={{ width: 100 }}
                        alt="Гэрчилгээний ард тал"
                      />
                    )}
                    <div>{_.truncate(state.certificateBack?.name, { length: 13 }) ?? ''}</div>
                  </Space>
                ) : (
                  <Button icon={<UploadOutlined />}>Хуулах</Button>
                )}
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Divider />
        <Title level={5}>Салбарын мэдээлэл</Title>
        <Row gutter={16} style={{ marginTop: 20 }}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Салбарын нэр"
              name="branchName"
              rules={[
                {
                  required: true,
                  message: 'Салбарын нэр оруулна уу',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Салбарын утас"
              name="branchPhoneNumber"
              rules={[
                {
                  required: true,
                  message: 'Салбарын утас оруулна уу',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <AddressUnitsSelector
          selectedUnits={addressArray}
          onChange={onHandleAddress}
          styleProps={addressStyleProps}
        />
        <Row gutter={16} style={{ marginTop: 20 }}>
          <Col xs={24} xl={16}>
            <Form.Item
              label="Салбарын дэлгэрэнгүй хаяг"
              name="branchAddressDetail"
              rules={[
                {
                  required: false,
                  message: 'Салбарын дэлгэрэнгүй хаяг оруулна уу',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </div>
      <StepFooter submitText="Хүсэлт илгээх" loading={submitting} />
    </Form>
  );
};

export default OrganizationForm;
